{
    "features-majority-account-no-ssn": {
        "meta": {
            "title": "Mobile banking without SSN - MAJORITY",
            "description": "We’re making banking more accessible. Open an account with a passport, matrícula consular, or other government-issued ID if you don’t have an SSN."
        },
        "hero": {
            "title": "Mobile banking without SSN",
            "body": "We’re making banking more accessible. Open an account with a passport, matrícula consular, or other government-issued ID if you don’t have an SSN.",
            "cta": "Sign up",
            "features": [],
            "disclaimer": "*The MAJORITY app facilitates banking services through Axiom Bank N.A., Member FDIC.",
            "circle": "No SSN required"
        },
        "no_ssn_content_box": {
            "tagline": "Majority Account",
            "title": "Get an account without SSN",
            "body": "Regardless of immigration status, everyone deserves access to basic financial services. Open an account and get a free Visa® debit card even without an SSN. Simply verify your identity with a government-issued ID, such as a passport or matrícula consular.",
            "canvas": "No SSN required",
            "cta": "Get started"
        },
        "compare_fees_content_box": {
            "tagline": "Majority Account",
            "title": "No SSN? No problem",
            "body": "Here are some of the documents you can use to verify your identity:\n* Social Security Number (SSN)\n* Individual Taxpayer Identification Number (ITIN)\n* Valid passport\n* Mexican matrícula consular\n* Driver’s license\n* State ID\n* Immigration ID or residence permit\n* Other government-issued ID with photo",
            "cta": "Sign up"
        },
        "citizen_content_box": {
            "title": "Do I need to be a us citizen to open an account?",
            "body": "No. We believe in personality over nationality, which is why we welcome citizens and non-citizens alike. Simply verify your information with a government-issued ID to unlock the full money-saving benefits of our all-in-one mobile banking app. No extra costs to open an account or special in-person appointments required.",
            "cta": "Get started"
        }
        }
}